// Kiosk self-update (CJ 2026-10-17). The Bristol iPad went 30+ days without a
// page load, so every fix since then — Open Tally included — never reached it.
// While the kiosk sits on the PIN pad it asks the server which revision is live
// and reloads when that differs from the one this page was served by.

// The page's build id is the Cloud Run revision (data-build on <html>); the
// health probe reports the same name. Off Cloud Run the page build is a
// timestamp and the probe says 'local', so never reload there.
export function isStale(pageBuild, liveRevision) {
  if (!pageBuild || !liveRevision || liveRevision === 'local') return false;
  return pageBuild !== liveRevision;
}

export async function liveRevision(fetchImpl = fetch) {
  const r = await fetchImpl('/api/v1/health', { cache: 'no-store' });
  if (!r.ok) return null;
  const body = await r.json();
  return body.revision || null;
}
